import { render, staticRenderFns } from "./DlgEventDelete.vue?vue&type=template&id=887bcc14&scoped=true&"
import script from "./DlgEventDelete.vue?vue&type=script&lang=js&"
export * from "./DlgEventDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887bcc14",
  null
  
)

export default component.exports